module.exports = __webpack_public_path__ + "static/images/calsync.d0e6e245eb63a5084e98e9a9b85f9734.svg";